import type { ReactNode } from "react";
import { cn } from "../../lib/utils";
import { Icon } from "../../primitives";

export const searchFieldInputClass =
	"min-w-0 flex-1 bg-transparent text-primary outline-none placeholder:text-tertiary";

export const SearchField = ({
	className,
	children,
}: {
	className?: string;
	children: ReactNode;
}) => (
	<div className={cn("flex min-w-0 items-center gap-2", className)}>
		<Icon type="magnifying-glass" size="mini" color="tertiary" aria-hidden />
		{children}
	</div>
);
